import axios from "axios";
import Vue from "vue";
import { Toast } from 'vant';
import { getToken, removeToken } from "./auth";
import { getDefaultLanguage } from "./common";
import { clearAltchaToken, getAltchaToken } from "./altchaGate";
import router from '../router'
import store from '../store'
Vue.use(Toast);
// 创建axios实例
const service = axios.create({
  baseURL: '', // api的base_url
  timeout: 100000, // 请求超时时间
  headers: { "Cache-Control": "no-cache", Pragma: "no-cache"}
});

// 添加请求拦截器
service.interceptors.request.use(
  request => {
    let token = getToken();
    if (token) {
      request.headers['token'] = token;
    }
    const altchaToken = getAltchaToken();
    if (altchaToken) {
      request.headers['X-Altcha-Token'] = altchaToken;
    }
    request.headers.language = localStorage.getItem('locale') || getDefaultLanguage()
    
    // Add device fingerprint header if available
    const fingerprint = localStorage.getItem('device_fingerprint') || getCookieValue('device_fingerprint');
    if (fingerprint) {
      request.headers['X-Device-Fingerprint'] = fingerprint;
    }
    
    return request
  },
  error => {
    return Promise.reject(error);
  }
);

// Helper function to get cookie value
function getCookieValue(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

// 拦截返回的数据res,通过返回值直接获取到服务器的数据
service.interceptors.response.use(
  response => {
    const res = response.data;

    if (res && typeof res === 'object') {
      res.__serverDate = response.headers?.date || null
    }
    
    // Check for blacklist response (code 4001)
    if (res.code === 4001) {
      // Save blacklist info to localStorage
      localStorage.setItem('blacklist_info', JSON.stringify({
        reason: res.data?.reason || 'Unknown reason',
        ip: res.data?.ip || 'Unknown',
        id: res.data?.fingerprint || 'Unknown'
      }));
      
      // Redirect to blocked page
      router.push('/blocked');
      return Promise.reject(new Error('Blacklisted'));
    }
    if (res.code === 4401) {
      clearAltchaToken()
      if (router.currentRoute.name !== 'altchaVerify') {
        router.replace({ name: 'altchaVerify' })
      }
    }
    
    return res
  },
  error => {
    if (error.response?.status == 401 || error.response?.status == 403) {
      removeToken()
      store.state.isLogin = false

      const current = router.currentRoute
      const whiteArr = ['login', 'register', 'resetPassword', 'download']
      // 避免 /login → /login 的无限跳转
      if (whiteArr.indexOf(current.name) === -1) {
        router.push({
          name: 'login',
          query: { redirect: current.fullPath }
        })
      }
    }
    return Promise.reject(error);
  }
);

export default service;
